import { createFileRoute } from "@tanstack/react-router";
import { McpTools } from "@/routes/help/mcp-tools";

export const Route = createFileRoute("/dashboard/help/mcp-tools")({
	component: McpTools,
});
